import { useEffect } from "react"
import { showToast } from "components/Toast"

export const useHandleToast = ({
  sucessCondition,
  errorCondition,
  sucessMsg,
  errorMsg,
  toastProps
}) => {
  useEffect(() => {
    if (errorCondition) {
      showToast({
        message: errorMsg,
        type: "error",
        ...toastProps
      })

      return
    }

    if (sucessCondition) {
      showToast({
        message: sucessMsg,
        type: "sucess",
        ...toastProps
      })
    }
  }, [errorCondition, sucessCondition])
}



// WEBPACK FOOTER //
// ./src/hooks/useHandleToast.js